import api from '@/config/api'
import vuex from '@/store'
import catchErrors from './catchErrors'

// const headers = {
//     'x-rapidapi-host': 'vanitysoft-boundaries-io-v1.p.rapidapi.com',
//     'x-rapidapi-key': 'secret'
// }

export default {
  getUserPreferences(emp_id) {
    return catchErrors.get(`/v2/newsdesk/users/${emp_id}/preferences/user`, {
      cache: {
        maxAge: 120 * 1000,
        ignoreCache: true
      }
    })
  },
  createUserPreferences(emp_id, data) {
    return catchErrors.post(`/v2/newsdesk/users/${emp_id}/preferences/user`, data)
  },
  updateUserPreferences(emp_id, key, data) {
    if (data == null) throw new Error('Data cannot be null')
    const wrappedData = {
      value: data
    }
    return catchErrors.patch(`/v2/newsdesk/users/${emp_id}/preferences/user/${key}`, wrappedData)
  },
  deleteUserPreferences(emp_id, key) {
    if (key) {
      return catchErrors.delete(`/v2/newsdesk/users/${emp_id}/preferences/user/${key}`)
    }
    return catchErrors.delete(`/v2/newsdesk/users/${emp_id}/preferences/user`)
  },
  // station param is optional on the station-preference functions: admin
  // contexts can pass the station being edited; everything else defaults to
  // the current workspace.
  //
  // NOT migrated to the ?filter[station_id][]= convention (ND-1490): unlike
  // user preferences, PreferenceRepository::getPreferences() keys station-type
  // preferences by type_id = the station NAME itself (`where('type_id', $id)`),
  // not a numeric id. The new `users/{id}/preferences/{type}` route resolves
  // station via .stationFrom(User::class), which requires {id} to be a real
  // numeric user id — passing a station name into it would fail to resolve.
  // ND-1485 never added a station-preference-shaped equivalent route. Left on
  // the legacy path; flagged in the ND-1490 changelog as a backend gap.
  getStationPreferences(station = null) {
    station = station || vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.get(`/v2/newsdesk/${station}/${station}/preferences/station`, {
      cache: {
        maxAge: 120 * 1000,
        ignoreCache: true
      }
    })
  },
  createStationPreferences(data, station = null) {
    station = station || vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.post(`/v2/newsdesk/${station}/${station}/preferences/station`, data)
  },
  updateStationPreferences(key, data, station = null) {
    if (data == null) throw new Error('Data cannot be null')
    const wrappedData = {
      value: data
    }
    station = station || vuex.getters.currentStation.station
    if (!station) throw new Error('Station cannot be null')
    return catchErrors.patch(`/v2/newsdesk/${station}/${station}/preferences/station/${key}`, wrappedData)
  },
  deleteStationPreferences(key) {
    const station = vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.delete(`/v2/newsdesk/${station}/${station}/preferences/station/${key ?? ''}`)
  }
}
